import { BaseGridProps, GridPageView } from '../types';
import {
  GridColumn,
  GridConfig,
  WcgAdvancedFilter,
} from '@wcg/frontend-framework';

export enum SuffixChoice {
  Jr = 'Jr.',
  Sr = 'Sr.',
  II = 'II',
  III = 'III',
  IV = 'IV',
  V = 'V',
}

export const DEFAULT_PAGINATION_OPTIONS = new Set<number>([10, 25, 50, 100]);

export const DEFAULT_GRID_CONFIG: GridConfig = {
  advancedFilters: {},
  columns: {},
  features: {
    canDownloadAll: false,
    canExportAll: false,
    deleteAll: false,
    paginationOptions: new Set<number>([10, 25, 50, 100]),
    gridType: '',
  },
};

export const DEFAULT_GRID_SELECT_VIEW = {
  id: 'Default',
  label: 'Default View',
};

export const DEFAULT_CURRENT_GRID_VIEW = {
  advancedFilters: {},
  columns: {},
  default: true,
  gridType: '',
  id: 'default',
  name: 'Default View',
  pagination: 0,
  searchString: '',
  sorted: null,
};

export const DEFAULT_GRID_PAGE_VIEW: GridPageView = {
  page: 0,
  pageSize: 25,
};

export const DEFAULT_BASE_GRID_PROPS: BaseGridProps = {
  adFilters: {} as WcgAdvancedFilter,
  baselineAdFilters: {} as WcgAdvancedFilter,
  canCloseDialog: false,
  columnsCopy: {},
  config: DEFAULT_GRID_CONFIG,
  currentGridView: DEFAULT_CURRENT_GRID_VIEW,
  currentStateDestroyed: false,
  error: null,
  isLoading: true,
  isTableColumnChanged: false,
  pageView: DEFAULT_GRID_PAGE_VIEW,
  searchString: '',
  selectedView: DEFAULT_GRID_SELECT_VIEW,
  sort: null,
  total: 0,
};

export const DEFAULT_ACTION_COLUMN: GridColumn = {
  componentType: 'action',
  dragDisabled: true,
  key: 'action',
  label: 'action',
  maxWidth: 50,
  minWidth: 10,
  ordinal: -1,
  propKey: 'action',
  sortable: false,
  sorted: null,
  sticky: true,
  stickyEnd: false,
};

export const DEFAULT_CHECKBOX_COLUMN: GridColumn = {
  componentType: 'checkbox',
  dragDisabled: true,
  key: 'checkbox',
  label: 'checkbox',
  maxWidth: 50,
  minWidth: 10,
  ordinal: -2,
  propKey: 'checkbox',
  sortable: false,
  sorted: null,
  sticky: true,
  stickyEnd: false,
};

export const organizationRoleHints = new Map<string, string>([
  ['member', 'Member have view-only access to the Organization Profile page.'],
  [
    'controller',
    'Controllers  have permission to edit and delete any information on the Organization Profile page.',
  ],
  [
    'coordinator',
    'Coordinator can edit and remove members from the Organization Profile but have view-only access to all other organization details.',
  ],
]);
